import { Configuration } from "Configuration";
import { BaseService } from "./BaseService";
import { CommandService } from "./CommandService";
import { IDataRow } from "Entities";
import { DataRequestOption, DatabaseImageResult, ImageClient, MultipleControlRequestParameter } from "./Client";

export class DatabaseImageService extends BaseService {
    /**
     * Get data for all databaseimages for a row.
     * @param gridId Id of the grid.
     * @param options List of request options.
     * @param dataRow Current datarow in grid / form.
     */
    public getAll(gridId: number, options: DataRequestOption[], dataRow: IDataRow): Promise<{ [controlID: number]: DatabaseImageResult }> {
        const client = new ImageClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        const params = <MultipleControlRequestParameter>(
            $.extend(CommandService.getRequestParameters(), { DataRow: dataRow }, { DataRequestOptions: options })
        );

        return this.handleResult(
            new Promise<{ [controlID: number]: DatabaseImageResult }>((resolve, reject) => {
                /*let xhr = */ client.get(
                    gridId,
                    params,
                    (res) => resolve(res),
                    (exception, reason) => reject(exception)
                );
            })
        );
    }
}
